export const weekdays = [
    {
        tm: "Ýekşenbe",
        ru: "Воскресенье",
        en: "Sunday"
    },
    {
        tm: "Duşenbe",
        ru: "Понедельник",
        en: "Monday"
    },
    {
        tm: "Sişenbe",
        ru: "Вторник",
        en: "Tuesday"
    },
    {
        tm: "Çarşenbe",
        ru: "Среда",
        en: "Wednesday"
    },
    {
        tm: "Penşenbe",
        ru: "Четверг",
        en: "Thursday"
    },
    {
        tm: "Anna",
        ru: "Пятница",
        en: "Friday"
    },
    {
        tm: "Şenbe",
        ru: "Суббота",
        en: "Saturday"
    }
];

export const months = [
    {
        tm: "Ýanwar",
        ru: "Январь",
        en: "January"
    },
    {
        tm: "Fewral",
        ru: "Февраль",
        en: "February"
    },
    {
        tm: "Mart",
        ru: "Март",
        en: "March"
    },
    {
        tm: "Aprel",
        ru: "Апрель",
        en: "April"
    },
    {
        tm: "Maý",
        ru: "Май",
        en: "May"
    },
    {
        tm: "Iýun",
        ru: "Июнь",
        en: "June"
    },
    {
        tm: "Iýul",
        ru: "Июль",
        en: "Jule"
    },
    {
        tm: "Awgust",
        ru: "Август",
        en: "August"
    },
    {
        tm: "Sentýabr",
        ru: "Сентябрь",
        en: "September"
    },
    {
        tm: "Oktýabr",
        ru: "Октябрь",
        en: "October"
    },
    {
        tm: "Noýabr",
        ru: "Ноябрь",
        en: "November"
    },
    {
        tm: "Dekabr",
        ru: "Декабрь",
        en: "December"
    }
];

export const regions = {
    "Ashgabat": {
        tm: "Aşgabat",
        ru: "Ашхабад",
        en: "Ashgabat"
    },
    "Lebap": {
        tm: "Lebap",
        ru: "Лебап",
        en: "Lebap"
    },
    "Mary": {
        tm: "Mary",
        ru: "Мары",
        en: "Mary"
    },
    "Balkan": {
        tm: "Balkan",
        ru: "Балкан",
        en: "Balkan"
    },
    "Dashoguz": {
        tm: "Daşoguz",
        ru: "Дашогуз",
        en: "Dashoguz"
    },
    "Ahal": {
        tm: "Ahal",
        ru: "Ахал",
        en: "Ahal"
    }
};

export const getPostDate = (sene) => {
    return `${sene.substring(8, 10)}.${sene.substring(5, 7)}.${sene.substring(0, 4)}`;
}

export const getNoticeDay = (date) => {
    var dateObj = new Date(date);
    return dateObj.getDate() < 10 ? "0" + dateObj.getDate() : dateObj.getDate();
}

export const getNoticeMonth = (date, lang) => {
    var dateObj = new Date(date);
    return months[dateObj.getMonth()][lang];
}

export const getNoticeYear = (date) => {
    var dateObj = new Date(date);
    return dateObj.getFullYear();
}